import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useDownlinePoints = (id, page, term = '') => useQuery({ queryKey: [`downline-points`, id, page, term], queryFn: async () => {
    if(!id) return {}
    const callback = await API.get(`/downlines/${id}/points?page=${page}${term ? `&term=${term}` : ''}`)
    return callback?.data
}})

export default useDownlinePoints